export const ORDER_TYPE = {
  OSAGO: 1,
  BUS: 2,
  GREEN_CARD: 3,
  DGO: 4,
  TOURISM: 5,
  AUTOLAWYER: 6,
  EXTERNAL: 7,
  HOME: 8,
  MINIKASKO: 9,
  PETS: 10,
};
